var LISTBOX_DATA_TESTIDS = {
  startAdornmentContainer: "mntl-listbox-item-start-adornment",
  endAdornmentContainer: "mntl-listbox-item-end-adornment"
};

export { LISTBOX_DATA_TESTIDS };
